<template>
  <a-modal
    v-model:visible="visible"
    title="版本升级"
    ok-text="关闭"
    :width="600"
    :after-close="afterClose"
  >
    <div class="mb-6">
      <div class="text-center text-base text-green-500 mt-2">
        有新版本，请点击更新升级!
      </div>
      <!-- 更新内容 -->
      <div v-if="versionTexts.length" class="mt-6 px-12">
        <div>更新内容：</div>
        <div
          v-for="versionText in versionTexts"
          :key="versionText"
          class="mt-3 opacity-65"
        >
          {{ versionText }}
        </div>
      </div>
    </div>
    <template #footer>
      <a-button @click="handleCancle">暂不更新</a-button>
      <a-button type="primary" @click="handleok">更新</a-button>
    </template>
  </a-modal>
</template>

<script setup lang="ts">
import { useWebVersion } from '@/hooks';
import { ElectronApi } from '@/services/electron.api';
import { nextTick, ref } from 'vue';

const { getLastestBuildTime } = useWebVersion();

const visible = ref<boolean>(false);
defineExpose({
  open: async () => {
    visible.value = true;
    await nextTick();
    fetchVersionMessage();
  }
});

const versionTexts = ref<string[]>([]);

const fetchVersionMessage = async () => {
  try {
    const buildTime = await getLastestBuildTime();
    if (!buildTime) return;

    const textVersion = buildTime
      ?.split(' ')
      .map((item) => item.replaceAll(':', '.'))
      .join(' ')
      .trimStart()
      .trimEnd();

    const { origin, pathname } = window.location;
    const pathname2 = pathname.replace('/index.html', '');
    const url =
      origin +
      (pathname2 == '/' ? '' : pathname2) +
      `/version_log/${textVersion}.txt`;

    const texts = await window
      .fetch(url, {
        cache: 'no-store'
      })
      .then((res) => {
        if (res.status !== 200) {
          throw new Error('版本内容请求失败');
        }
        return res.text();
      });

    versionTexts.value = texts?.split('\n');
  } catch (error) {
    console.error('版本内容请求失败', error);
    versionTexts.value = [];
  }
};

const handleok = () => {
  visible.value = false;
  ElectronApi.reload();
};
const handleCancle = () => {
  visible.value = false;
};
const afterClose = () => {
  versionTexts.value = [];
};
</script>

<style scoped></style>
